import { SDKConfig } from "@sdk/default-sdk-config";
import { EntityServices } from "@sdk/utils/entity.service";
import { iCustomerPaymentMethod } from "./customer-payment-method-model";
import axios from "axios";

export class CustomerPaymentMethodsServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }
  constructor(protected config: { basePath: string; token: string }) {
    this.customerPaymentMethods.configure(config);
  }

  customerPaymentMethods = new EntityServices<iCustomerPaymentMethod>(
    SDKConfig,
    "customer-payment-methods",
    {}
  );

  validatePDQFormula = async (body: { formula: string; amount?: number }) => {
    const results = await axios.post<{
      valid: boolean;
      value?: number;
      error?: string;
    }>(
      this.config.basePath + `/customer-payment-methods/validate-pdq-formula`,
      body,
      { headers: { Authorization: this.config.token } }
    );
    return results.data;
  };
}
